<template>
  <aside class="sidebar" :class="{ 'sidebar--open': open }">
    <!-- Logo -->
    <div class="sidebar__brand">
      <div class="sidebar__logo">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/onthego-c56b3.appspot.com/o/resources%2FLogo.webp?alt=media&token=4c6d0589-924d-4ebd-b7bf-a1e957f75dca"
          alt="OnTheGo"
        />
      </div>
      <span class="sidebar__brand-name">OnTheGo</span>
      <button class="sidebar__close" @click="$emit('close')">
        <b-icon icon="x-lg"></b-icon>
      </button>
    </div>

    <!-- Información del usuario -->
    <div class="sidebar__user">
      <div class="sidebar__avatar">{{ userInitials }}</div>
      <div class="sidebar__user-info">
        <span class="sidebar__user-name">{{ userName }}</span>
        <span class="sidebar__user-role">Administrador</span>
      </div>
    </div>

    <!-- Navegación -->
    <nav class="sidebar__nav">
      <div v-for="group in navGroups" :key="group.label" class="sidebar__group">
        <span class="sidebar__group-label">{{ group.label }}</span>
        <router-link
          v-for="item in group.items"
          :key="item.path"
          :to="item.path"
          class="sidebar__link"
          :class="{ 'sidebar__link--active': isActive(item.path) }"
          active-class=""
          exact-active-class=""
          @click.native="$emit('close')"
        >
          <span class="sidebar__link-icon">
            <b-icon :icon="item.icon"></b-icon>
          </span>
          <span class="sidebar__link-text">{{ item.label }}</span>
          <span v-if="item.badge" class="sidebar__badge">{{ item.badge }}</span>
        </router-link>
      </div>
    </nav>

    <!-- Footer -->
    <div class="sidebar__footer">
      <button class="sidebar__logout" @click="cerrarSesion">
        <b-icon icon="box-arrow-left"></b-icon>
        <span>Cerrar sesión</span>
      </button>
    </div>
  </aside>
</template>

<script>
import { auth, signOut } from './../resources/firebaseConfig'

export default {
  name: 'AppSidebar',
  props: { open: { type: Boolean, default: true } },
  emits: ['close'],
  data() {
    return {
      navGroups: [
        {
          label: 'Catálogo',
          items: [
            { path: '/Marcas',    icon: 'patch-check-fill',   label: 'Marcas' },
            { path: '/Submarcas', icon: 'layers-fill',        label: 'Submarcas' },
            { path: '/Modelos',   icon: 'box-seam',           label: 'Modelos' },
          ]
        },
        {
          label: 'Marketing',
          items: [
            { path: '/Promociones', icon: 'percent',          label: 'Promociones' },
            { path: '/Novedades',   icon: 'megaphone-fill',   label: 'Novedades' },
          ]
        },
        {
          label: 'Comunidad',
          items: [
            { path: '/Usuarios',    icon: 'people-fill',      label: 'Usuarios' },
            { path: '/Sugerencias', icon: 'lightbulb-fill',   label: 'Sugerencias' },
          ]
        },
        {
          label: 'Empresa',
          items: [
            { path: '/Aboutus', icon: 'info-circle-fill',     label: 'Nosotros' },
          ]
        }
      ]
    }
  },
  computed: {
    userName() { return sessionStorage.getItem('Nombre') || 'Admin' },
    userInitials() {
      const n = this.userName
      const parts = n.trim().split(' ')
      return parts.length >= 2
        ? (parts[0][0] + parts[1][0]).toUpperCase()
        : n.slice(0, 2).toUpperCase()
    }
  },
  methods: {
    isActive(path) {
      const current = this.$route.path.toLowerCase();
      const base = path.toLowerCase();
      // Exact match OR sub-route (e.g. /Modelos active when at /modelos/id/estilos)
      return current === base || current.startsWith(base + '/');
    },
    async cerrarSesion() {
      try {
        await signOut(auth)
      } catch (_) { /* */ }
      sessionStorage.clear()
      this.$router.push('/').catch(e => {
        if (e.name !== 'NavigationDuplicated') throw e
      })
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: var(--sidebar-width);
  background: var(--primary);
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: fixed;
  top: 0; left: 0;
  z-index: 200;
  transition: transform 0.3s ease;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.15) transparent;
}

.sidebar::-webkit-scrollbar { width: 4px; }
.sidebar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }

/* Mobile: hidden by default */
@media (max-width: 991px) {
  .sidebar { transform: translateX(-100%); }
  .sidebar--open { transform: translateX(0); box-shadow: 4px 0 24px rgba(0,0,0,0.25); }
}

/* Brand */
.sidebar__brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.sidebar__logo img {
  width: 36px; height: 36px;
  border-radius: 8px;
  object-fit: cover;
  background: rgba(255,255,255,0.15);
}

.sidebar__brand-name {
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: 0.5px;
  flex: 1;
  color: #fff;
}

.sidebar__close {
  background: none; border: none; color: rgba(255,255,255,0.6);
  cursor: pointer; padding: 4px; border-radius: 6px;
  font-size: 1rem; display: none;
  transition: color 0.2s;
}
.sidebar__close:hover { color: #fff; }

@media (max-width: 991px) { .sidebar__close { display: flex; } }

/* User */
.sidebar__user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  background: rgba(0,0,0,0.15);
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

.sidebar__avatar {
  width: 36px; height: 36px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--primary);
  font-weight: 800;
  font-size: 0.8rem;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

.sidebar__user-info { display: flex; flex-direction: column; }
.sidebar__user-name { font-size: 0.875rem; font-weight: 600; color: #fff; line-height: 1.2; }
.sidebar__user-role { font-size: 0.7rem; color: rgba(255,255,255,0.55); }

/* Nav */
.sidebar__nav { flex: 1; padding: 12px 0; }

.sidebar__group { margin-bottom: 8px; }

.sidebar__group-label {
  display: block;
  padding: 8px 20px 4px;
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: rgba(255,255,255,0.4);
}

.sidebar__link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  color: rgba(255,255,255,0.75);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0;
  transition: all 0.18s;
  margin: 1px 8px;
  border-radius: 8px;
}

.sidebar__link:hover {
  background: rgba(255,255,255,0.1);
  color: #fff;
  text-decoration: none;
}

.sidebar__link--active {
  background: var(--accent) !important;
  color: var(--primary) !important;
  font-weight: 700;
}

.sidebar__link-icon { font-size: 1rem; width: 20px; text-align: center; }
.sidebar__link-text { flex: 1; }

.sidebar__badge {
  background: var(--accent);
  color: var(--primary);
  font-size: 0.65rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 10px;
}

/* Footer */
.sidebar__footer {
  padding: 14px 16px;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.sidebar__logout {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 8px;
  color: rgba(255,255,255,0.75);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.18s;
}

.sidebar__logout:hover {
  background: rgba(229,62,62,0.25);
  border-color: rgba(229,62,62,0.4);
  color: #fff;
}
</style>
